module.exports = __webpack_public_path__ + "static/media/cancel_icon_black.9c6689e2.png";